// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay-module__overlay___2grj-","blind":"Overlay-module__blind___2zPxB"};